/*@ngInject*/
const UIRequiredIndicatorDirective = function () {

    let linkFunction = function ($scope) {
        $scope.showGreen = false;

        $scope.$watch('value', function (newValue) {

            if (!_.isNil($scope.validator)) {
                $scope.showGreen = $scope.validator();
            }
            else {
                $scope.showGreen = !_.isNil(newValue) && newValue !== '';
            }
        });
    };

    return {
        restrict: 'E',
        replace: true,
        scope: {
            value: '@',
            validator: '&?'
        },
        link: linkFunction,
        templateUrl: '/ui/requiredIndicator/uiRequiredIndicator.tpl.html'
    };
};

angular.module('umCore')
    .directive('uiRequiredIndicator', UIRequiredIndicatorDirective);
